import { render, staticRenderFns } from "./create-report-patient.vue?vue&type=template&id=76ed510d&scoped=true"
import script from "./create-report-patient.vue?vue&type=script&lang=js"
export * from "./create-report-patient.vue?vue&type=script&lang=js"
import style0 from "./create-report-patient.vue?vue&type=style&index=0&id=76ed510d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ed510d",
  null
  
)

export default component.exports